































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HelloWorld extends Vue {
  tableData: Array<Object>;

  search = '';

  odnowDialogVisible = false;

  poinformujDialogVisible = false;

  form = {
    name: '',
    region: '',
    date1: '',
    date2: '',
    delivery: false,
    type: [],
    resource: '',
    desc: '',
  };

  constructor() {
    super();
    this.tableData = [{
      createdBy: 'system',
      who: 'HOUSE',
      type: 'zbliża się przegląd',
      description: 'Wyślij przypomnienie (1 z 3) terminie ważności przeglądu klimatyzacji (koniec za 7 dni)',
      createdAt: '2020-01-02',
    }, {
      createdBy: 'system',
      who: 'HOUSE',
      type: 'zbliża się przegląd',
      description: 'Wyślij przypomnienie (2 z 3) dla HOUSE o terminie ważności przeglądu klimatyzacji (koniec za 5 dzień)',
      createdAt: '2020-01-02',
    }, {
      createdBy: 'system',
      who: 'HOUSE',
      type: 'zbliża się przegląd',
      description: 'Wyślij przypomnienie (3 z 3) dla HOUSE o terminie ważności przeglądu klimatyzacji (koniec za 3 dzień)',
      createdAt: '2020-01-02',
    }, {
      createdBy: 'Łukasz Koperniak',
      who: 'HOUSE',
      type: 'zbliża się przegląd',
      description: 'Wyślij przypomnienie dla HOUSE o terminie ważności przeglądu klimatyzacji (koniec za 1 dni)',
      createdAt: '2020-01-02',
    }, {
      createdBy: 'system',
      who: 'HOUSE',
      type: 'koniec przeglądu',
      description: 'Wyślij informację do HOUSE o końcu terminu przeglądu klimatyzacji',
      createdAt: '2020-01-02',
    }, {
      createdBy: 'system',
      who: 'HOUSE',
      type: 'przegląd nieważny',
      description: 'Wyślij informację do HOUSE o przedawnieniu przeglądu klimatyzacji - 1 dzień przedawnienia',
      createdAt: '2020-01-02',
    }, {
      createdBy: 'system',
      who: 'HOUSE',
      type: 'przegląd nieważny',
      description: 'Wyślij informację do HOUSE o przedawnieniu przeglądu klimatyzacji - 2 dzień przedawnienia',
      createdAt: '2020-01-02',
    }];
  }

  // eslint-disable-next-line class-methods-use-this
  filterHandler(value: any, row: any, column: any) {
    // eslint-disable-next-line prefer-destructuring
    const property = column.property;
    return row[property] === value;
  }
}
